<div class="header-structure">
  <div
    role="button"
    tabindex="0"
    [attr.aria-label]="totalPriceDescription()"
    [ngClass]="{ 'your-quote-section': !isMobile() }"
    (click)="!isStandalone() && toggleQuoteOverview()"
    (keyup.enter)="!isStandalone() && toggleQuoteOverview()"
  >
    @if (isMobile()) {
      <p class="total-price">{{ totalPrice() | currency }}</p>
    }

    <div class="your-quote-section">
      <span class="your-quote-text">{{ yourQuote() }}</span>
      @if (!isStandalone() || isMobile()) {
        <pc-icon [@rotateChevron]="currentChevronState()" [icon]="currentChevronIcon()" [size]="'xsmall'"> </pc-icon>
      }
    </div>
  </div>

  @if (!isMobile()) {
    <p class="total-price">{{ totalPrice() | currency }}</p>
  }
</div>

@if (isStandalone()) {
  <pc-separator></pc-separator>
}
